'use client';

import React, { forwardRef } from 'react';
import styles from './Toggler.module.css';

export interface TogglerProps {
    checked?: boolean;
    defaultChecked?: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    name?: string;
    id?: string;
    className?: string;
    label?: string;
    labelPosition?: 'left' | 'right';
}

const Toggler = forwardRef<HTMLInputElement, TogglerProps>(
    (
        {
            checked,
            defaultChecked,
            disabled = false,
            onChange,
            name,
            id,
            className = '',
            label,
            labelPosition = 'right',
        },
        ref
    ) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange?.(e.target.checked);
        };

        const togglerClasses = [
            styles.toggler,
            disabled ? styles.disabled : '',
            className,
        ].filter(Boolean).join(' ');

        return (
            <label className={togglerClasses}>
                {label && labelPosition === 'left' && (
                    <span className={styles.label}>{label}</span>
                )}
                <input
                    ref={ref}
                    type="checkbox"
                    checked={checked}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    onChange={handleChange}
                    name={name}
                    id={id}
                    className={styles.input}
                />
                <span className={styles.track}>
                    <span className={styles.thumb} />
                </span>
                {label && labelPosition === 'right' && (
                    <span className={styles.label}>{label}</span>
                )}
            </label>
        );
    }
);

Toggler.displayName = 'Toggler';

export default Toggler;
